// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1ZzKU","topBottomGutter":"Layout_topBottomGutter__3U5P3"};